import React from "react";
import {connect} from "react-redux";
import Header from "../../../common/components/Header";
import {Button, Confirm, Grid, Modal} from "semantic-ui-react";
import BillingSidebarButtons from "../../shared/BillingSidebarButtons";
import Breadcrumb from "../../../common/partials/Breadcrumb/Breadcrumb";
import {
    deletePricingTableV2,
    fetchOnePricingTableV2,
    openEditPricingTableModalV2,
    toggleDeletePricingTableModalV2,
    toggleEditPricingTableModalV2,
    updatedPricingTableRefreshV2,
    validatePricingTableV2,
    fetchCountryPricesV2,
    openEditCountryPricingModalV2,
    closeCountryPricingModalV2,
    validateEditCountryPricingFormV2,
    toggleAddCountryPricingModalV2,
    toggleDeleteCountryPriceModalV2, deleteCountryLevelPricingV2, toggleAddPricingSchemeModalV2,
    unmountPricingDetailPageV2,
} from "../actions/PricingTablesActions";
import {setBreadCrumb} from "../../../veritas/breadcrumb/BreadcrumbActions";
import PricingDetailPageInfo from "./PricingDetailPageInfo";
import AddEditPricingFormV2 from "./AddEditPricingFormV2";
import LastUpdated from "../../../common/partials/LastUpdated";
import TenantSidebarV2 from "./TenantSidebarV2";
import Sidebar from "../../../common/components/Sidebar";
import AddEditCountryPricingFormV2 from "./AddEditCountryPricingFormV2";
import * as Validation from "../../../common/utils/Validation";

export class PricingTableDetailPage extends React.Component {

    componentDidMount() {
        const {pricingID} = this.props.params;
        this.props.getPricingTableDetail(pricingID);
        this.props.getCountryPrices(pricingID);

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/v2/pricing-tables', text: 'Pricing Tables' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {pricingID} = this.props.params;
        if (this.props.updatedPricingTableV2) {
            this.props.getPricingTableDetail(pricingID);
            this.props.updatedPricingTableRefresh();
        }
        document.title = `Pricing - ` + this.props.pricingTableDetailsV2.name;

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/v2/pricing-tables', text: 'Pricing Tables' },
            service: { url: `/billing/v2/pricing-tables/${pricingID}`, text: this.props.pricingTableDetailsV2.name},
            source: { url: '', text: '' }
        })
    }

    componentWillUnmount() {
        this.props.unmountPricingDetail();
    }

    handleEditPricingTable = () => {
        const { pricingTableDetailsV2, basePrice, countryPricesV2 } = this.props;
        pricingTableDetailsV2.base_price = basePrice;
        // check the country prices keys, look if the keys contain a tiered scheme
        // and add a value to the payload for yes/no, depending on which edit to PT will
        // display corresponding options. Default is false.
        let containsTieredPricingScheme = false;
        Object.keys(countryPricesV2).forEach(p => {
            if (p.toLowerCase().includes("tiered")) {
                containsTieredPricingScheme = true;
            }
        });
        this.props.openEditPricingTableModal(this.props.pricingTableDetailsV2, containsTieredPricingScheme);
    }

    handleEditPricingTableClick = () => {
        Validation.clearMessages();
        this.props.toggleEditPricingTableModal()
    }

    handleEditPricingFormSubmit = () => {
        this.props.validatePricingTableForm(this.props.pricingTableObjectV2);
    }

    handleDeletePricingTable = () => {
        this.props.toggleDeletePricingTableModal();
    }

    handleDeletePricingTableSubmitClick = () => {
        this.props.deletePricingTable(this.props.pricingTableDetailsV2.pricing_id);
    }

    handleDeletePricingCancelClick = () => {
        this.props.toggleDeletePricingTableModal();
    }

    handleCloseCountryPricingClick = () => {
        this.props.closeCountryPricingModal();
    }

    handleCloseAddCountryPricingClick = () => {
        this.props.toggleAddCountryPricingModalV2();
    }

    handleEditCountryPricingFormSubmit = () => {
        this.props.validateEditCPFormV2(this.props.countryPricingObject)
    }

    handleAddCountryPricingFormSubmit = () => {
        this.props.validateEditCPFormV2(this.props.countryPricingObject)
    }

    handleDeleteCountryPricingClick = () => {
        this.props.deleteCountryPriceV2(this.props.pricingTableDetailsV2.pricing_id, this.props.countryPricingIDForDelete);
    }

    handleCancelDeleteForCountryPricingClick = () => {
        this.props.toggleDeleteCountryPricingModal();
    }

    handleCloseAddPricingSchemeClick = () => {
        this.props.toggleAddNewPricingScheme("");
    }

    handleAddPricingSchemeFormSubmit = () => {
        this.props.validateEditCPFormV2(this.props.countryPricingObject)
    }

    get pricingTableName() {
        const {pricingTableDetailsV2} = this.props;
        return (
            <div className="detail-page-header">
                <h1>{pricingTableDetailsV2.name}</h1>
                <div className={"last-updated"}>
                    <label>Last Updated On:
                        <LastUpdated lastUpdated={pricingTableDetailsV2.last_updated} />
                    </label>
                    <label>By: {pricingTableDetailsV2.updated_by}</label>
                </div>
            </div>
        );
    }

    pageContent() {
        return (
            <div className={"pricing-detail-page"}>
                <Grid>
                    <Grid.Column width={12}>
                        {this.pricingTableName}
                        <PricingDetailPageInfo
                            pricingTableDetailsV2={this.props.pricingTableDetailsV2}
                            pricingTableTenants={this.props.pricingTableTenants}
                            basePrice={this.props.basePrice}
                            countryPriceTables={this.props.countryPricesV2}
                            editButton={this.handleEditPricingTable}
                            deleteButton={this.handleDeletePricingTable}
                            canEdit={this.props.canEdit}
                        />
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <TenantSidebarV2 tenants={this.props.pricingTableTenants}/>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }

    render() {
        const {
            editPTModalOpen,
            deletePTWarning,
            pricingTableDetailsV2,
            editCountryPricingModalOpen,
            addCountryPricingModalOpen,
            deleteCountryPriceWarning,
            addPricingSchemeModalOpen,
        } = this.props;
        return(
            <div className='billing'>
                <Header />
                <Grid>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {Object.keys(pricingTableDetailsV2).length === 0
                            ? null
                            : this.pageContent()
                        }
                    </Grid.Column>
                </Grid>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={editPTModalOpen}
                >
                    <Modal.Header>
                        {"Edit Pricing Table Details"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditPricingFormV2 />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleEditPricingTableClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleEditPricingFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={editCountryPricingModalOpen}
                >
                    <Modal.Header>
                        {"Edit Country Pricing Details"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditCountryPricingFormV2 />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseCountryPricingClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleEditCountryPricingFormSubmit}
                            >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={addCountryPricingModalOpen}
                >
                    <Modal.Header>
                        {"Add A Country to Pricing Table"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditCountryPricingFormV2 />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseAddCountryPricingClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddCountryPricingFormSubmit}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={addPricingSchemeModalOpen}
                >
                    <Modal.Header>
                        {"Add New Pricing Scheme to the Pricing Table"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditCountryPricingFormV2 />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseAddPricingSchemeClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddPricingSchemeFormSubmit}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={deletePTWarning}
                    header='Delete Pricing Table'
                    content="Are you sure you want to delete this Pricing Table?"
                    confirmButton="Delete"
                    onCancel={this.handleDeletePricingCancelClick}
                    onConfirm={this.handleDeletePricingTableSubmitClick}
                />

                <Confirm
                    open={deleteCountryPriceWarning}
                    header='Delete Pricing Information.'
                    content="Are you sure you want to delete this Country Level Pricing?"
                    confirmButton="Delete"
                    onCancel={this.handleCancelDeleteForCountryPricingClick}
                    onConfirm={this.handleDeleteCountryPricingClick}
                />

            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    countryPricesV2: state.billing.pricing.countryPricesV2,
    basePrice: state.billing.pricing.basePrice,
    pricingTableDetailsV2: state.billing.pricing.pricingTableDetailsV2,
    pricingTableTenants: state.billing.pricing.pricingTableTenants,
    updatedPricingTableV2: state.billing.pricing.updatedPricingTableV2,

    pricingTableObjectV2: state.billing.addEditPricingTable.pricingTableObjectV2,
    editPTModalOpen: state.billing.addEditPricingTable.editPTModalOpen,
    deletePTWarning: state.billing.addEditPricingTable.deletePTWarning,

    addCountryPricingModalOpen: state.billing.addEditCountryPricing.addCountryPricingModalOpen,
    editCountryPricingModalOpen: state.billing.addEditCountryPricing.editCountryPricingModalOpen,
    addPricingSchemeModalOpen: state.billing.addEditCountryPricing.addPricingSchemeModalOpen,
    deleteCountryPriceWarning: state.billing.addEditCountryPricing.deleteCountryPriceWarning,
    countryPricingIDForDelete: state.billing.addEditCountryPricing.countryPricingIDForDelete,
    countryPricingObject: state.billing.addEditCountryPricing.countryPricingObject,

    canEdit: state.marvel.user.access.accessLevel.isPricingAdmin,
});

const mapDispatchToProps = dispatch => ({
    getPricingTableDetail: (pricingID) => {dispatch(fetchOnePricingTableV2(pricingID))},
    getCountryPrices: (pricingID) => {dispatch(fetchCountryPricesV2(pricingID))},
    updatedPricingTableRefresh: () => {dispatch(updatedPricingTableRefreshV2())},
    openEditPricingTableModal: (pricingTableObjectV2,containsTieredPricingScheme) => {
        dispatch(openEditPricingTableModalV2(pricingTableObjectV2, containsTieredPricingScheme))},
    toggleEditPricingTableModal: () => {dispatch(toggleEditPricingTableModalV2())},
    validatePricingTableForm: (pricingTableObjectV2) => {dispatch(validatePricingTableV2(pricingTableObjectV2))},
    toggleDeletePricingTableModal: () => {dispatch(toggleDeletePricingTableModalV2())},
    deletePricingTable: (pricingID) => {dispatch(deletePricingTableV2(pricingID))},
    openEditCountryPricingModal: (pricingID) => {dispatch(openEditCountryPricingModalV2(pricingID))},
    closeCountryPricingModal: () => {dispatch(closeCountryPricingModalV2())},
    validateEditCPFormV2: (countryPricingObjectV2) => {dispatch(validateEditCountryPricingFormV2(countryPricingObjectV2))},
    toggleAddCountryPricingModalV2: () => {dispatch(toggleAddCountryPricingModalV2())},
    toggleDeleteCountryPricingModal: (countryPricingID) => {dispatch(toggleDeleteCountryPriceModalV2(countryPricingID))},
    deleteCountryPriceV2: (pricingID, countryPricingID) => {
        dispatch(deleteCountryLevelPricingV2(pricingID, countryPricingID))},
    toggleAddNewPricingScheme: (pricingID) => {dispatch(toggleAddPricingSchemeModalV2(pricingID))},

    unmountPricingDetail: () => { dispatch(unmountPricingDetailPageV2()) },

    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PricingTableDetailPage)
